import React, { useEffect, useState } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import PropTypes from "prop-types";
import { format } from "date-fns";
import moment from "moment";
import RatingAndReview from "../ratingAndReview";
import UsePagination from "../pagination";
import {
  Avatar,
  Box,
  Button,
  Card,
  Checkbox,
  Table,
  Tooltip,
  TableBody,
  TableSortLabel,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from "@mui/material";
import { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import InfoIcon from "@mui/icons-material/Info";
import "../../../common.css";
import OrderDetailsDialog from "../upcoming_session/OrderDetailsDialog";
import { DEFAULT_ORDER_DATA } from "../../../../constants";
import axios from 'axios';
// import { getInitials } from '../../utils/get-initials';

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "rgba(80, 80, 80, 0.92)",
    color: "#ffff",
    fontWeight: "500",
    maxWidth: 350,
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid rgba(80, 80, 80, 0.92)",
    overflowX: "hidden",
    overflowY: "scroll",
    maxHeight: "300px",
  },
}));

export const CustomerListResults = (props) => {
  const [openClass, setOpenClass] = useState(false);

  const [orderData, setOrderData] = useState(DEFAULT_ORDER_DATA);
  const [orderDetails, setOrderDetails] = useState({});
  const [typeTemp, setTypeTemp] = useState();

  const [selectedCustomerIds, setSelectedCustomerIds] = useState([]);
  const [limit, setLimit] = useState(5);
  const [page, setPage] = useState(0);
  const isMusicTutor = JSON.parse(window.localStorage.getItem('tutor'))?.saveTutor?.tutor_type === 'Music'
  let tutor = JSON.parse(localStorage.getItem("tutor"));
  function currentData(data, itemsPerPage) {
    const begin = page * itemsPerPage;
    const end = begin + itemsPerPage;
    // setPageVal( data?.slice(begin, end));
    return data?.slice(begin, end);
  }
  useEffect(() => {
    currentData(
      props.historyAr !== undefined && props.historyAr.length !== 0
        ? props.historyAr
        : props.sessionUser,
      limit
    );
  }, [page]);

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
  };

   const fetchOrderApiCall = async(tutorId , orderId) =>{
      if (tutor && tutor.accessToken && !tutor.refreshToken) {
        return  await axios.get(
        `https://musiclancerapigcp-dev.el.r.appspot.com/v1/api/orders/doers/order-sessions-details/orderId/${orderId}/${tutorId}`,
          {
            headers: { "x-auth-token": tutor.accessToken },
          }
      );
      }
      else if (tutor && tutor.refreshToken) {
    
        let payload = {
          token: tutor.refreshToken,
         
        }
    
        try {
          const res = await axios.post(`https://musiclancerapigcp-dev.el.r.appspot.com/v1/api/auth/refresh`, payload);
          if (res.data.accessToken) {
            tutor.accessToken = res.data.accessToken
            tutor.refreshToken = res.data.refreshToken
            localStorage.setItem("tutor", JSON.stringify(tutor));
          }
        } catch (err) {
          localStorage.removeItem("tutor");
          console.log(err);
        }
        return  await axios.get(
        `https://musiclancerapigcp-dev.el.r.appspot.com/v1/api/orders/doers/order-sessions-details/orderId/${orderId}/${tutorId}`,
          {
            headers: { "x-auth-token": tutor.accessToken },
          }
      );
      }
      else {
        return  await axios.get(
          `https://musiclancerapigcp-dev.el.r.appspot.com/v1/api/orders/doers/order-sessions-details/orderId/${orderId}/${tutorId}`,
            {
              headers: { "x-auth-token": tutor.accessToken },
            }
        );
      }
    }

  const fetchOrderValue = async(tutorId , orderId) =>{
    console.log("testing fetchOrder value")
    const singleOrder = await fetchOrderApiCall(tutorId , orderId);
    console.log({singleOrder})
    // await axios.get(
    //   `https://musiclancerapigcp-dev.el.r.appspot.com/v1/api/orders/doers/order-sessions-details/orderId/${orderId}/${tutorId}`,
    //     {
    //       headers: { "x-auth-token": tutor.accessToken },
    //     }
    // );
    if(singleOrder && singleOrder?.data?.success)setOrderDetails(singleOrder?.data?.result)
  }

  const handlePageChange = (event, newPage) => {
    console.log({ newPage });
    // const begin = (newPage - 1) * limit;
    // const end = begin + limit;
    setPage(newPage);
    // setPagrAr((props?.historyAr!==undefined && props?.historyAr?.length!==0) ? (props?.historyAr.slice(begin,end)):(props?.sessionUser.slice(begin,end)));
  };

  const getClassDetails = async (type, tutorId ,orderId) => {
    try {
      console.log({checkurgent : tutorId ,orderId})
      await fetchOrderValue(tutorId , orderId)
      setTypeTemp(type)

     setOpenClass(true)
    } catch (error) {
      console.error("Error:", error);

    }
  };

  return (
    <Card>
      <PerfectScrollbar>
        <Box sx={{ minWidth: 1050 }}>
          <Table>
            <TableHead>
              <TableRow style={{ backgroundColor: "#8c8c98" }}>
                <TableCell padding="checkbox">
                  {/* <Checkbox
                    checked={selectedCustomerIds.length === customers.length}
                    color="primary"
                    indeterminate={
                      selectedCustomerIds.length > 0
                      && selectedCustomerIds.length < customers.length
                    }
                    onChange={handleSelectAll}
                  /> */}
                </TableCell>
                <TableCell style={{ color: "white", fontWeight: "600" }}>
                  {isMusicTutor ? 'Course ID' : 'Task Id'}
                </TableCell>
                <TableCell style={{ color: "white", fontWeight: "600" }}>
                  {isMusicTutor ? 'Course' : 'Subject'}
                </TableCell>

                <TableCell
                  sortDirection="desc"
                  style={{ color: "white", fontWeight: "600" }}
                >
                  {/* <Tooltip
                  enterDelay={300}
                  title="Sort"
                >
                  <TableSortLabel
                    active
                    direction="desc"
                  > */}
                  Date
                  {/* </TableSortLabel>
                </Tooltip> */}
                </TableCell>

                <TableCell style={{ color: "white", fontWeight: "600" }}>
                  Type
                </TableCell>
                <TableCell style={{ color: "white", fontWeight: "600" }}>
                  Amount
                </TableCell>

                <TableCell style={{ color: "white", fontWeight: "600" }}>
                  Status
                </TableCell>
                {
                  isMusicTutor &&
                  <TableCell style={{ color: "white", fontWeight: "600" }}>
                    Details
                  </TableCell>
                }
                {/* <TableCell style={{color:"white",fontWeight:"600"}}>
                  Rating & Reviews
                </TableCell> */}
              </TableRow>
            </TableHead>
            <TableBody>
              {currentData(
                props.historyAr !== undefined && props.historyAr.length !== 0
                  ? props.historyAr
                  : props.sessionUser,
                limit
              ) !== undefined &&
                currentData(
                  props.historyAr !== undefined && props.historyAr.length !== 0
                    ? props.historyAr
                    : props.sessionUser,
                  limit
                ).length !== 0 ? (
                currentData(
                  props.historyAr !== undefined && props.historyAr.length !== 0
                    ? props.historyAr
                    : props.sessionUser,
                  limit
                )?.map((customer) => (
                  <TableRow
                    hover
                    key={customer?.sessionId}
                    selected={selectedCustomerIds.indexOf(customer?.id) !== -1}
                  >
                    <TableCell padding="checkbox">
                      <Checkbox
                        checked={customer?.work_status === "Completed"}
                        // onChange={(event) => handleSelectOne(event, customer?.id)}
                        value="true"
                      />
                    </TableCell>
                    <TableCell>
                      <Box
                        sx={{
                          alignItems: "center",
                          display: "flex",
                        }}
                      >
                        {/* <Avatar
                        src={customer?.avatarUrl}
                        sx={{ mr: 2 }}
                      > */}
                        {/* {getInitials(customer?.name)} */}
                        {/* </Avatar> */}
                        <Typography color="textPrimary" variant="body1">
                          {customer?.sessionId}
                        </Typography>
                      </Box>
                    </TableCell>
                    <TableCell>{customer?.subject}</TableCell>
                    <TableCell>
                      {moment(customer?.deadline)?.format("ll")}
                    </TableCell>
                    <TableCell>
                      {/* {`${customer?.address.city}, ${customer?.address.state}, ${customer?.address.country}`} */}
                      {customer?.type}
                    </TableCell>
                    <TableCell>
                      {customer?.wallet && customer?.wallet.length > 0 ? (
                        <HtmlTooltip
                          placement="top"
                          title={
                            <>
                              <Typography>
                                <h5
                                  style={{
                                    color: "white",
                                    display: "block",
                                  }}
                                >Wallet Payment</h5>
                              </Typography>
                              {customer?.wallet.map((eachTransaction, i) => {
                                return (
                                  <Typography>
                                    <span
                                      style={{
                                        color: "white",
                                        display: "block",
                                      }}
                                    >
                                      {i + 1}. Status:
                                      {eachTransaction?.status === "full" &&
                                        " 100%"}
                                      {eachTransaction?.status === "partial" &&
                                        " 70%"}
                                    </span>

                                    {eachTransaction?.status === "full" &&
                                      eachTransaction?.fullAmount && (
                                        <span
                                          style={{
                                            color: "white",
                                            display: "block",
                                          }}
                                        >
                                          Amount: &#x20b9;{" "}
                                          {eachTransaction?.fullAmount}
                                        </span>
                                      )}
                                    {eachTransaction?.status === "partial" &&
                                      eachTransaction?.partialAmount && (
                                        <span
                                          style={{
                                            color: "white",
                                            display: "block",
                                          }}
                                        >
                                          Amount: &#x20b9;{" "}
                                          {eachTransaction?.partialAmount}
                                        </span>
                                      )}

                                    {eachTransaction?.updatedAt && (
                                      <span
                                        style={{
                                          color: "white",
                                          display: "block",
                                        }}
                                      >
                                        Date:{" "}
                                        {moment(
                                          eachTransaction?.updatedAt
                                        ).format("ll LT")}
                                      </span>
                                    )}
                                    <span>-------------------------</span>
                                  </Typography>
                                );
                              })}
                            </>
                          }
                        >
                          &#x20b9;{" "}
                          {customer?.tutor_dealt_amount
                            ? +customer?.tutor_dealt_amount / 100
                            : "--"}{" "}
                          <InfoIcon
                            style={{ width: "16px", marginBottom: "4px" }}
                          />
                        </HtmlTooltip>
                      ) : (
                        <>
                          &#x20b9;{" "}
                          {customer?.tutor_dealt_amount
                            ? +customer?.tutor_dealt_amount / 100
                            : "--"}
                        </>
                      )}
                    </TableCell>

                    <TableCell>{customer?.work_status}</TableCell>
                    <TableCell>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => getClassDetails(customer?.type ,customer?.tutor_id, customer?.order_id ) }
                      >
                        Class Details
                      </Button>
                    </TableCell>
                    <OrderDetailsDialog handleClose={() => { setOpenClass(false) }} open={openClass}  orderDetails={orderDetails} type={typeTemp} />

                  </TableRow>
                ))
              ) : props?.sessionUser?.length !== 0 ? (
                props?.sessionUser?.map((customer) => (
                  <TableRow
                    hover
                    key={customer?.sessionId}
                    selected={selectedCustomerIds.indexOf(customer?.id) !== -1}
                  >
                    <TableCell padding="checkbox">
                      <Checkbox
                        checked={customer?.work_status === "Completed"}
                        // onChange={(event) => handleSelectOne(event, customer.id)}
                        value="true"
                      />
                    </TableCell>
                    <TableCell>
                      <Box
                        sx={{
                          alignItems: "center",
                          display: "flex",
                        }}
                      >
                        {/* <Avatar
                        src={customer.avatarUrl}
                        sx={{ mr: 2 }}
                      > */}
                        {/* {getInitials(customer.name)} */}
                        {/* </Avatar> */}
                        <Typography color="textPrimary" variant="body1">
                          {customer?.sessionId}
                        </Typography>
                      </Box>
                    </TableCell>
                    <TableCell>{customer?.subject}</TableCell>
                    <TableCell>
                      {moment(customer?.deadline).format("ll")}
                    </TableCell>
                    <TableCell>
                      {/* {`${customer.address.city}, ${customer.address.state}, ${customer.address.country}`} */}
                      {customer?.type}
                    </TableCell>
                    {/* <TableCell>
                      &#x20b9;{" "}
                      {customer?.tutor_dealt_amount
                        ? +customer?.tutor_dealt_amount / 100
                        : "--"}
                    </TableCell> */}
                    <TableCell>
                      {customer?.wallet && customer?.wallet.length > 0 ? (
                        <HtmlTooltip
                          placement="top"
                          title={
                            <>
                              <Typography>
                                <h5
                                  style={{
                                    color: "white",
                                    display: "block",
                                  }}
                                >Wallet Payment</h5>
                              </Typography>
                              {customer?.wallet.map((eachTransaction, i) => {
                                return (
                                  <Typography>
                                    <span
                                      style={{
                                        color: "white",
                                        display: "block",
                                      }}
                                    >
                                      {i + 1}. Status:
                                      {eachTransaction?.status === "full" &&
                                        " 100%"}
                                      {eachTransaction?.status === "partial" &&
                                        " 70%"}
                                    </span>

                                    {eachTransaction?.status === "full" &&
                                      eachTransaction?.fullAmount && (
                                        <span
                                          style={{
                                            color: "white",
                                            display: "block",
                                          }}
                                        >
                                          Amount: &#x20b9;{" "}
                                          {eachTransaction?.fullAmount}
                                        </span>
                                      )}
                                    {eachTransaction?.status === "partial" &&
                                      eachTransaction?.partialAmount && (
                                        <span
                                          style={{
                                            color: "white",
                                            display: "block",
                                          }}
                                        >
                                          Amount: &#x20b9;{" "}
                                          {eachTransaction?.partialAmount}
                                        </span>
                                      )}

                                    {eachTransaction?.updatedAt && (
                                      <span
                                        style={{
                                          color: "white",
                                          display: "block",
                                        }}
                                      >
                                        Date:{" "}
                                        {moment(
                                          eachTransaction?.updatedAt
                                        ).format("ll LT")}
                                      </span>
                                    )}
                                    <span>-------------------------</span>
                                  </Typography>
                                );
                              })}
                            </>
                          }
                        >
                          &#x20b9;{" "}
                          {customer?.tutor_dealt_amount
                            ? +customer?.tutor_dealt_amount / 100
                            : "--"}{" "}
                          <InfoIcon
                            style={{ width: "16px", marginBottom: "4px" }}
                          />
                        </HtmlTooltip>
                      ) : (
                        <>
                          &#x20b9;{" "}
                          {customer?.tutor_dealt_amount
                            ? +customer?.tutor_dealt_amount / 100
                            : "--"}
                        </>
                      )}
                    </TableCell>

                    <TableCell>{customer?.work_status}</TableCell>
                    {/* Add the button here */}

                    <TableCell>
                      
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => { }}
                      >
                        Action
                      </Button>
                    </TableCell>
                    <OrderDetailsDialog handleClose={() => { setOpenClass(false) }} open={openClass}  orderDetails={orderDetails} type={typeTemp} />

                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell style={{ fontStyle: "italic" }}>
                    {" "}
                    <span> No History Found!</span>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </Box>
      </PerfectScrollbar>
      <TablePagination
        component="div"
        count={Math.ceil(
          props.historyAr.length !== 0 && props.historyAr !== undefined
            ? props?.historyAr.length
            : props?.sessionUser.length
        )}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleLimitChange}
        page={page}
        rowsPerPage={limit}
        rowsPerPageOptions={[5, 10, 25]}
      />
      {/* <OrderDetailsDialog handleClose={() => { setOpenClass(false) }} open={openClass}  orderDetails={orderDetails} type={customer?.type} /> */}

    </Card>

  );
};

// CustomerListResults.propTypes = {
//   customers: PropTypes?.array?.isRequired
// };
